import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';
import {DefaultAppPageModule} from '../../../../../../../components/common/defaut-application-page/default-app-page.module';
import {SaleInvoiceSaveModule} from '../../../api/component/sale-invoice-save/sale-invoice-save.module';
import {SaleInvoiceSaveDialogPage} from './sale-invoice-save-dialog.page';
import {DialogModule} from '../../../../../../common/dialog/dialog.module';
import {ButtonModule} from "../../../../../../core/component/button/button.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        DefaultAppPageModule,
        SaleInvoiceSaveModule,
        DialogModule,
        ButtonModule,
    ],
    declarations: [SaleInvoiceSaveDialogPage]
})
export class SaleInvoiceSaveDialogModule {
}
